<template>
  <div v-if="product" class="popup-dv-mask" @click.self="$emit('close')">
    <div class="popup-dv">
      <!-- HEADER -->
      <div class="popup-dv-header">
        <button class="btn rent action-btn" ref="rentIcon" style="width: auto !important">
          🛒 Thuê
          <span ref="cartBadge" style="color: white; font-size: 12px" v-if="rentCount">({{ rentCount }})</span>
        </button>

        <button class="btn buy action-btn" ref="buyIcon" style="width: auto !important">
          🛒 Mua
          <span ref="cartBadge" v-if="buyCount" style="color: white; font-size: 12px">({{ buyCount }})</span>
        </button>

        <span class="m-auto" style="font-size: 18px; font-weight: 700">
          {{ product.name }}
        </span>

        <button @click="$emit('close')">✕</button>
      </div>

      <!-- TABS -->
      <div class="tab-bar">
        <div v-for="t in tabs" :key="t" :class="['tab', { active: activeTab === t }]" @click="activeTab = t">
          {{ t }}
        </div>
      </div>

      <!-- CONTENT -->
      <div class="tab-content" style="    height: 500px;  overflow: auto;">
        <!-- TAB SẢN PHẨM -->
        <div v-if="activeTab === 'Sản phẩm'">
          <!-- ẢNH -->
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 col-md-7">
                <div class="d-flex">
                  <div class="main-img m-auto">
                    <img :src="currentImage" />
                  </div>

                  <div class="thumb-list flex-column mt-4">
                    <div v-for="(img, i) in images" :key="i" class="thumb" :class="{ active: img === currentImage }"
                      @click="currentImage = img">
                      <img :src="img" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- col-12 d-block d-md-none -->
              <div class="col-12 d-block d-md-none">
                <div v-if="comboProducts.length" class="combo-box mt-3">
                  <div class="combo-title">🎁 Sản phẩm trong combo</div>

                  <div class="combo-list">
                    <div v-for="sp in comboProducts" :key="sp.id" class="combo-item"
                      :class="{ active: selectedComboIds.includes(sp.id) }">
                      <img :src="sp.comboImg" class="combo-img" />

                      <div class="combo-name">
                        {{ sp.comboName }}
                      </div>

                      <div class="combo-price" style="color: blue">
                        {{ currenLang.textSanPhamThue }} :
                        {{ formatPrice(sp.giaThue) }}₫
                      </div>

                      <div class="combo-price">
                        {{ currenLang.textSanPhamBan }} :
                        {{ formatPrice(getComboPrice(sp)) }}₫
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-5">
                <!-- CHIẾT KHẤU -->
                <div class="discount-box mt-4">
                  <div v-for="s in saleList" :key="s" class="discount-row" :class="{ active: autoSale === s }">
                    <div class="discount-left">
                      {{ currenLang.textSanPham_ChietKhau }} {{ s }}%
                    </div>
                    <div class="discount-right">
                      {{ saleRules[Number(s)]?.text }}
                    </div>
                  </div>
                </div>

                <!-- SỐ LƯỢNG -->
                <div class="qty-box">
                  <div class="qty-label">
                    {{ currenLang.textSanPham_Soluong }}
                  </div>
                  <div class="qty-control justify-content-between">
                    <button @click="decreaseQty">−</button>
                    <input type="number" v-model.number="quantity" @input="onQtyChange" />
                    <button @click="increaseQty">+</button>
                  </div>
                  <div v-if="autoSale" class="sale-badge mt-3" style="color: red">
                    🔖 Đã áp dụng - {{ autoSale }}%
                  </div>
                  <!-- <div v-if="autoSale" class="save">
                🎉 Tiết kiệm
                {{ formatPrice(baseSellPrice * quantity - buyPrice) }}₫ 
              </div> -->
                </div>
                <div style="font-size: 13px" class="mt-3">
                  <i>
                    (*)
                    {{ currenLang.textSanPham_PhuongThuc }}
                  </i>
                </div>

                <div v-if="suggestedProducts.length" class="suggested-box mt-4 d-none">
                  <div class="suggested-title">
                    🔥 {{ currenLang.textSanPham_GoiY }}
                  </div>

                  <div class="suggested-list">
                    <div v-for="sp in suggestedProducts" :key="sp.id" class="suggested-item"
                      :class="{ active: selectedSuggestId === sp.id }" @click="toggleSuggest(sp)">
                      <img :src="sp.image.split(';')[0]" class="suggested-img" />

                      <div class="suggested-name text-center">
                        {{ sp.name }}
                      </div>

                      <div class="suggested-price text-center">
                        +
                        {{
                          activeTab === "Sản phẩm"
                            ? formatPrice(sp.giaThue)
                            : formatPrice(sp.price)
                        }}₫
                      </div>

                      <div v-if="selectedSuggestId === sp.id" class="check-icon">
                        ✔
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- d-md-block -->
              <div class="col-12 col-md-12 d-none d-md-block">
                <div v-if="comboProducts.length" class="combo-box mt-4">
                  <div class="combo-title">🎁 Sản phẩm trong combo</div>

                  <div class="combo-list">
                    <!-- <div v-for="sp in comboProducts" :key="sp.id" class="combo-item" :class="{ active: selectedComboIds.includes(sp.id) }" @click="toggleCombo(sp)"> -->

                    <div v-for="sp in comboProducts" :key="sp.id" class="combo-item"
                      :class="{ active: selectedComboIds.includes(sp.id) }">
                      <img :src="sp.comboImg" class="combo-img" />

                      <div class="combo-name">
                        {{ sp.comboName }}
                      </div>

                      <div class="combo-price" style="color: blue">
                        {{ currenLang.textSanPhamThue }} :
                        {{ formatPrice(sp.giaThue) }}₫
                      </div>

                      <div class="combo-price">
                        {{ currenLang.textSanPhamBan }} :
                        {{ formatPrice(getComboPrice(sp)) }}₫
                      </div>

                      <div v-if="selectedComboIds.includes(sp.id)" class="check-icon">
                        ✔
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- CHIẾT KHẤU + SỐ LƯỢNG -->

          <!-- BADGE SALE -->

          <!-- GIÁ TÓM TẮT -->
          <div class="price-summary d-none">
            <div v-if="autoSale" class="price-row">
              <span>Giá gốc</span>
              <span class="old">
                {{ formatPrice(baseSellPrice * quantity) }}₫
              </span>
            </div>

            <div class="price-row highlight">
              <span>Giá sau ưu đãi</span>
              <span class="final"> {{ formatPrice(buyPrice) }}₫ </span>
            </div>
          </div>
        </div>

        <!-- TAB THÔNG TIN -->
        <div v-if="activeTab === 'Thông tin'" class="p-4">
          <div class="desc" v-html="formatDesc(product.description)"></div>
          <div class="desc mt-3" v-html="formatDesc(product.huongdan)"></div>
          <div style="font-size: 13px; font-weight: 600" class="mt-3">
            {{ currenLang.textSanPham_HinhThucTT }}
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <!-- FOOTER -->
      <div class="popup-dv-footer">
        <!-- THUÊ -->
        <button ref="rentBtn" v-if="rentPrice > 0" class="btn rent action-btn" @click="
          flyToCart('rent');
        addToCart('rent', {
          product: product,
          quantity: quantity,
          unitPrice: Math.round(rentPrice / quantity),
          total: rentPrice,
          sale: autoSale,
        });
        ">
          <div class="btn-title">
            <span class="action-text">
              {{ currenLang.textSanPham_ThueNgay }} 📦
            </span>
            <span class="action-price"> {{ formatPrice(rentPrice) }}₫ </span>
          </div>
        </button>

        <!-- MUA -->
        <button ref="buyBtn" v-if="buyPrice > 0" class="btn buy action-btn" @click="
          flyToCart('buy');
        addToCart('buy', {
          product: product,
          quantity: quantity,
          unitPrice: Math.round(buyPrice / quantity),
          total: buyPrice,
          sale: autoSale,
        });
        ">
          <div class="btn-title">
            <span class="action-text">
              {{ currenLang.textSanPham_MuaNgay }} 🛒
            </span>
            <span class="action-price"> {{ formatPrice(buyPrice) }}₫ </span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div v-if="toast.show" class="toast">
    {{ toast.message }}
  </div>
</template>

<script>
import { languages } from "@/components/languages";

export default {
  props: { product: Object },

  data() {
    return {
      activeTab: "Sản phẩm",
      tabs: ["Sản phẩm", "Thông tin"],
      currentImage: "",
      quantity: 1,
      rentCount: 0,
      buyCount: 0,
      // products: [],
      products: require("@/components/json/jsonProduct.json"),
      selectedSuggestIds: [],
      selectedComboIds: [],
      selectedSuggestId: null,
      toast: {
        show: false,
        message: "",
      },
      currenLang: languages.vi,
    };
  },
  created() {
    const savedLanguage = localStorage.getItem("languages") || "vi";
    if (savedLanguage && languages[savedLanguage]) {
      this.currenLang = languages[savedLanguage];
    }
  },
  computed: {
    comboProducts() {
      if (!this.product?.combosp?.length) return [];

      return this.product.combosp
        .map((combo) => {
          const realProduct = this.products.find((p) => p.id === combo.id);

          if (!realProduct) return null;

          return {
            ...realProduct,
            comboImg: combo.img,
            comboName: combo.name,
            giaCombo: combo.giaCombo,
          };
        })
        .filter(Boolean);
    },
    comboTotal() {
      return this.comboProducts
        .filter((sp) => this.selectedComboIds.includes(sp.id))
        .reduce((sum, sp) => {
          return (
            sum +
            (this.activeTab === "Sản phẩm"
              ? Number(sp.giaThue)
              : Number(sp.price))
          );
        }, 0);
    },
    suggestTotal() {
      const sp = this.suggestedProducts.find(
        (s) => s.id === this.selectedSuggestId,
      );
      if (!sp) return 0;
      return this.activeTab === "Sản phẩm"
        ? Number(sp.giaThue)
        : Number(sp.price);
    },
    cartCount() {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      return cart.reduce((sum, i) => sum + i.quantity, 0);
    },
    images() {
      return this.product?.image?.split(";").filter(Boolean) || [];
    },

    saleList() {
      return this.product?.sale?.split(";").map(Number) || [];
    },

    saleRules() {
      return {
        5: { min: 5, max: 20, text: "5 – 20 sản phẩm" },
        10: { min: 21, max: 50, text: "21 – 50 sản phẩm" },
        15: { min: 51, max: Infinity, text: "Trên 50 sản phẩm" },
      };
    },

    autoSale() {
      let s = null;
      this.saleList.forEach((p) => {
        const r = this.saleRules[p];
        if (r && this.quantity >= r.min && this.quantity <= r.max) s = p;
      });
      return s;
    },
    suggestedProducts() {
      if (!this.product?.idsanphamgoiy) return [];

      const ids = this.product.idsanphamgoiy
        .split(";")
        .map((id) => Number(id))
        .filter(Boolean);

      return this.products.filter((p) => ids.includes(p.id));
    },
    baseSellPrice() {
      return Number(this.product?.priceTD) || 0;
    },

    baseRentPrice() {
      return Number(this.product?.giaThueTD) || 0;
    },

    buyPrice() {
      const priceTD = this.autoSale
        ? (this.baseSellPrice * (100 - this.autoSale)) / 100
        : this.baseSellPrice;

      return (
        Math.round(priceTD * this.quantity) +
        this.comboTotal +
        this.suggestTotal
      );
    },

    rentPrice() {
      const priceTD = this.autoSale
        ? this.product?.giaThueSaleTD?.[this.autoSale] || this.baseRentPrice
        : this.baseRentPrice;

      return (
        Math.round(priceTD * this.quantity) +
        this.comboTotal +
        this.suggestTotal
      );
    },
  },

  watch: {
    images: {
      immediate: true,
      handler(v) {
        if (v.length) this.currentImage = v[0];
      },
    },
  },

  methods: {
    getComboPrice(sp) {
      if (!sp.giaCombo) return 0;

      const arr = sp.giaCombo.split(";");
      console.log("arr ", arr);

      const defaultPrice = Number(arr[0]) || 0;
      const discountPrice = Number(arr[1]) || defaultPrice;

      if (this.autoSale == 5) {
        return discountPrice;
      } else if (this.autoSale == 10) {
        return discountPrice;
      }

      return defaultPrice;
    },
    toggleCombo(sp) {
      const index = this.selectedComboIds.indexOf(sp.id);

      if (index === -1) {
        this.selectedComboIds.push(sp.id);
      } else {
        this.selectedComboIds.splice(index, 1);
      }
    },
    toggleSuggest(sp) {
      // nếu click lại sản phẩm đang chọn → bỏ chọn
      if (this.selectedSuggestId === sp.id) {
        this.selectedSuggestId = null;
      } else {
        this.selectedSuggestId = sp.id;
      }
    },
    formatDesc(text) {
      if (!text) return "";
      return text
        .replace(/\n\n/g, "<br><br>") // xuống dòng đoạn
        .replace(/\n/g, "<br>") // xuống dòng thường
        .replace(/- /g, "• "); // gạch ngang → bullet
    },
    increaseQty() {
      this.quantity++;
    },
    decreaseQty() {
      if (this.quantity > 1) this.quantity--;
    },
    onQtyChange() {
      if (this.quantity < 1) this.quantity = 1;
    },

    formatPrice(v) {
      return Number(v).toLocaleString("vi-VN");
    },
    onBuy() {
      this.$emit("buy", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.buyPrice / this.quantity),
        total: this.buyPrice,
        sale: this.autoSale,
      });
    },

    onRent() {
      this.$emit("rent", {
        product: this.product,
        quantity: this.quantity,
        unitPrice: Math.round(this.rentPrice / this.quantity),
        total: this.rentPrice,
        sale: this.autoSale,
      });
    },
    addToCart(type) {
      const cart = JSON.parse(localStorage.getItem("cart") || "[]");
      // if (type === "rent") {
      //   this.rentCount += this.quantity;
      // }

      // if (type === "buy") {
      //   this.buyCount += this.quantity;
      // }
      const unitPrice =
        type === "buy"
          ? Math.round(this.buyPrice / this.quantity)
          : Math.round(this.rentPrice / this.quantity);

      const totalPrice = type === "buy" ? this.buyPrice : this.rentPrice;

      // 🔍 Tìm sản phẩm đã tồn tại (cùng id + cùng type + cùng sale)
      const existingIndex = cart.findIndex(
        (item) =>
          item.id === this.product.id &&
          item.type === type &&
          item.sale === this.autoSale,
      );

      if (existingIndex !== -1) {
        // ✅ Nếu đã có → cộng dồn số lượng
        cart[existingIndex].quantity += this.quantity;
        cart[existingIndex].total += totalPrice;
      } else {
        // ✅ Nếu chưa có → thêm mới
        cart.push({
          id: this.product.id,
          name: this.product.name,
          image: this.product.image?.split(";")[0],
          type,
          quantity: this.quantity,
          sale: this.autoSale,
          unitPrice,
          total: totalPrice,
        });
      }

      localStorage.setItem("cart", JSON.stringify(cart));
      this.$emit("added-to-cart", cart);
      window.dispatchEvent(new Event("cartUpdated"))

      // this.$emit("close")
      // window.location.reload();
    },
    flyToCart(type) {
      const startBtn = type === "rent" ? this.$refs.rentBtn : this.$refs.buyBtn;

      const endIcon =
        type === "rent" ? this.$refs.rentIcon : this.$refs.buyIcon;

      /* kiểm tra tồn tại */

      if (!startBtn || !endIcon) return;

      const start = startBtn.getBoundingClientRect();
      const end = endIcon.getBoundingClientRect();

      const img = document.createElement("img");

      img.src = this.product.image.split(";")[0];

      img.style.position = "fixed";
      img.style.left = start.left + "px";
      img.style.top = start.top + "px";
      img.style.width = "80px";
      img.style.zIndex = "9999";
      img.style.pointerEvents = "none";

      img.style.transition = "all .8s cubic-bezier(.65,-0.35,.35,1.35)";

      img.style.filter = "drop-shadow(0 10px 20px rgba(0,0,0,.25))";

      document.body.appendChild(img);

      setTimeout(() => {
        img.style.left = end.left + "px";
        img.style.top = end.top + "px";
        img.style.width = "30px";
        img.style.opacity = ".6";
      }, 50);

      setTimeout(() => {
        img.remove();

        if (type === "rent") {
          this.rentCount += this.quantity;
        }

        if (type === "buy") {
          this.buyCount += this.quantity;
        }
      }, 800);
    },
    // removeItem(index) {
    //   this.cartItems.splice(index, 1)
    //   localStorage.setItem("cart", JSON.stringify(this.cartItems))
    // },
  },
};
</script>

<style scoped>
.cart-icon {
  position: relative;
}

.cart-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #ff3b30;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 20px;
  font-weight: 700;
  transition: transform 0.25s;
}

.cart-badge.pop {
  transform: scale(1.4);
}

.cart-shake {
  animation: cartShake 0.4s;
}

@keyframes cartShake {
  0% {
    transform: rotate(0);
  }

  25% {
    transform: rotate(-10deg);
  }

  50% {
    transform: rotate(8deg);
  }

  75% {
    transform: rotate(-6deg);
  }

  100% {
    transform: rotate(0);
  }
}

/* ===== POPUP OVERLAY ===== */

.popup-dv-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* ===== POPUP CONTAINER ===== */

.popup-dv {
  width: 95%;
  max-width: 1100px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  animation: popupFade 0.25s ease;
}

@keyframes popupFade {
  from {
    transform: scale(0.96);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* ===== HEADER ===== */

.popup-dv-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.popup-dv-header span {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.popup-dv-header button {
  border: none;
  cursor: pointer;
}

.popup-dv-header .btn {
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 16px;
  height: 28px;
}

.popup-dv-header .rent {
  background: #ff4d4f;
  color: white;
}

.popup-dv-header .buy {
  background: #1890ff;
  color: white;
}

.popup-dv-header button:last-child {
  font-size: 22px;
  background: none;
  color: #777;
}

/* ===== TAB ===== */

.tab-bar {
  display: flex;
  border-bottom: 1px solid #eee;
}

.tab {
  flex: 1;
  text-align: center;
  padding: 10px;
  font-weight: 600;
  cursor: pointer;
  color: #666;
  transition: 0.2s;
}

.tab.active {
  color: #ff4d4f;
  border-bottom: 3px solid #ff4d4f;
}

.tab:hover {
  background: #fafafa;
}

/* ===== MAIN IMAGE ===== */

.main-img {
  background: #fff;
  border-radius: 12px;
  padding: 10px;
}

.main-img img {
  width: 100%;
  max-height: 420px;
  object-fit: contain;
}

/* ===== THUMBNAIL ===== */

.thumb-list {
  margin-left: 10px;
  display: flex;
  gap: 10px;
}

.thumb {
  width: 70px;
  height: 70px;
  border-radius: 10px;
  border: 2px solid transparent;
  overflow: hidden;
  cursor: pointer;
  transition: 0.2s;
}

.thumb img {
  width: 100%;
}

.thumb.active {
  border-color: #ff4d4f;
  transform: scale(1.05);
}

/* ===== DISCOUNT ===== */

.discount-box {
  border-radius: 12px;
  border: 1px solid #eee;
  overflow: hidden;
  background: #fafafa;
}

.discount-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
}

.discount-row:last-child {
  border-bottom: none;
}

.discount-row.active {
  background: #fff2f0;
  color: #ff4d4f;
  font-weight: 600;
}

/* ===== QUANTITY ===== */

.qty-box {
  margin-top: 20px;
}

.qty-label {
  font-weight: 600;
  margin-bottom: 8px;
}

.qty-control {
  display: flex;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.qty-control button {
  width: 40px;
  border: none;
  background: #f5f5f5;
  font-size: 18px;
  cursor: pointer;
}

.qty-control input {
  flex: 1;
  border: none;
  text-align: center;
  font-size: 15px;
}

/* ===== COMBO PRODUCT ===== */

.combo-box {
  margin-top: 20px;
}

.combo-title {
  font-weight: 700;
  margin-bottom: 10px;
}

.combo-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.combo-item {
  width: 160px;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  transition: 0.2s;
  cursor: pointer;
  background: #fff;
}

.combo-item:hover {
  border-color: #1890ff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

.combo-item.active {
  border: 2px solid #1890ff;
}

.combo-img {
  width: 80px;
  margin: auto;
}

.combo-name {
  font-size: 13px;
  font-weight: 600;
  margin-top: 5px;
}

.combo-price {
  font-size: 13px;
}

/* ===== FOOTER ===== */

.popup-dv-footer {
  display: flex;
  gap: 14px;
  padding: 16px;
  border-top: 1px solid #eee;
  background: #fff;
}

.popup-dv-header .action-btn {
  width: 80px;
  height: 30px;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 16px;
  flex: none;
  color: white;
}

.action-btn {
  flex: 1;
  border: none;
  border-radius: 12px;
  padding: 10px;
  font-size: 14px;
  color: white;
  font-weight: 700;
  cursor: pointer;
  transition: 0.25s;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.popup-dv-footer .rent {
  background: linear-gradient(45deg, #ff512f, #dd2476);
}

.popup-dv-footer .buy {
  background: linear-gradient(45deg, #1e88e5, #0d47a1);
}

.btn-title {
  display: flex;
  justify-content: space-between;
}

.action-text {
  font-weight: 600;
}

.action-price {
  font-weight: 800;
}

/* ===== TOAST ===== */

.toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 10px 18px;
  border-radius: 8px;
  font-size: 14px;
}
</style>
